export default __webpack_public_path__ + "static/thumbnail-0059abc54a3a972ee302af029644d955.png";